import React, {useState} from 'react'
import withContext from "../withContext";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { useHistory } from "react-router-dom";
import PrivacyPolicy from './Privacy Policy for yekaterinazhmud.pdf'
import Row from 'react-bootstrap/Row';


class Formsincheckout extends React.Component {
    constructor (props) {
    super(props);

    }


    componentDidMount(){
        window.scrollTo(0, 250);
      }
    onSubmit(){
    }


        render() {
            const accept = this.props.context.acceptForms;
            let email = "";
            let firstName = "";
            let lastName = "";
            let region = "";
            let country = "";
            let City = "";
            let Street = "";
            let HouseN = "";
            let Zip = "";

            {this.props.context.buyer.email ? (email = this.props.context.buyer.email) : (email = "")}
            {this.props.context.buyer.name ? (firstName = this.props.context.buyer.name) : (firstName = "")}
            {this.props.context.buyer.lastName ? (lastName = this.props.context.buyer.lastName) : (lastName = "")}
            {this.props.context.buyer.country ? (country = this.props.context.buyer.country) : (country = "")}
            {this.props.context.buyer.region ? (region = this.props.context.buyer.region) : (region = "")}
            {this.props.context.buyer.city ? (City = this.props.context.buyer.city) : (City = "")}
            {this.props.context.buyer.street ? (Street = this.props.context.buyer.street) : (Street = "")}
            {this.props.context.buyer.houseN ? (HouseN = this.props.context.buyer.houseN) : (HouseN = "")}
            {this.props.context.buyer.index ? (Zip = this.props.context.buyer.index) : (Zip = "")}

            let DisabledValue = false;

            function FormValids () {

                const [validated, setValidated] = useState(false);
                const [submitedemail, setSubmitedemail] = useState(email);
                const [submitedFirstName, setSubmitedFirstName] = useState(firstName);
                const [submitedLastName, setSubmitedLastName] = useState(lastName);
                const [submitedCountry, setCountry] = useState(country);
                const [submitedRegion, setRegion] = useState(region);
                const [submitedCity, setSubmitedCity] = useState(City);
                const [submitedStreet, setSubmitedStreet] = useState(Street);
                const [submitedHouseN, setSubmitedHouseN] = useState(HouseN);
                const [submitedZip, setSubmitedZip] = useState(Zip);



                let history = useHistory();
                DisabledValue = DisabledValue;

                const handleEmailChange = (val) => {
                    setSubmitedemail(val.target.value)
                }
                
                const handleNameChange = (val) => {
                    setSubmitedFirstName(val.target.value)
                }

                const handleLastNameChange = (val) => {
                    setSubmitedLastName(val.target.value)
                }

                const handleCityChange = (val) => {
                    setSubmitedCity(val.target.value)
                }
                const handleStreetChange = (val) => {
                    setSubmitedStreet(val.target.value)
                }
                const handleHouseNChange = (val) => {
                    setSubmitedHouseN(val.target.value)
                }
                const handleZipChange = (val) => {
                    setSubmitedZip(val.target.value)
                }

                const selectCountry = (val) => {
                    setCountry(val);
                    setRegion("")
                }

                const selectRegion = (val) => {
                    setRegion(val)
                }


                function HandleSubmit (event) {
                const form = event.currentTarget;


                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                } 

                if (form.checkValidity() === true) {

                    if (submitedCountry === "" || submitedRegion === ""){
                        event.preventDefault();
                        event.stopPropagation();
                            if (country === ""){
                                document.getElementsByClassName('RegionDropDown')[0].style.borderColor = "#ff0040";
                                document.getElementsByClassName('CountryDropdown')[0].style.borderColor = "#ff0040"
                                } else {
                                document.getElementsByClassName('RegionDropDown')[0].style.borderColor = "#ff0040"
                            }

                    } else {
                        document.getElementsByClassName('RegionDropDown')[0].style.borderColor = "#ced4da";
                        document.getElementsByClassName('CountryDropdown')[0].style.borderColor = "#ced4da";
                        accept(form);
                        history.push('/finalSummary');
                    }

                    
                }
                setValidated(true)

                }

        
    
                                return (
                                    <div className="container mt-4">
                                        <Row className="justify-content-center">
                                            <Col lg={8}>
                                                <h4 className="mb-4 text-center">Please enter your contact and delivery details</h4>

                                                <Form noValidate validated={validated} onSubmit={HandleSubmit}>
                                                    {/* Email */}
                                                    <Row>
                                                        <Col md={12} className="mb-3">
                                                            <Form.Group controlId="validationEmail">
                                                                <Form.Control
                                                                    required
                                                                    type="email"
                                                                    placeholder="E-mail address"
                                                                    value={submitedemail}
                                                                    onChange={handleEmailChange}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    {/* Names */}
                                                    <Row>
                                                        <Col md={6} className="mb-3">
                                                            <Form.Group controlId="validationFirstName">
                                                                <Form.Control
                                                                    required
                                                                    type="text"
                                                                    placeholder="First Name"
                                                                    value={submitedFirstName}
                                                                    onChange={handleNameChange}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={6} className="mb-3">
                                                            <Form.Group controlId="validationLastName">
                                                                <Form.Control
                                                                    required
                                                                    type="text"
                                                                    placeholder="Last Name"
                                                                    value={submitedLastName}
                                                                    onChange={handleLastNameChange}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    {/* Country / Region */}
                                                    <Row>
                                                        <Col md={6} className="mb-3">
                                                            <Form.Group controlId="validationCountry">
                                                                <CountryDropdown
                                                                    value={submitedCountry}
                                                                    onChange={(val) => selectCountry(val)}
                                                                    className="CountryDropdown form-control"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={6} className="mb-3">
                                                            <Form.Group controlId="validationRegion">
                                                                <RegionDropdown
                                                                    country={submitedCountry}
                                                                    value={submitedRegion}
                                                                    onChange={(val) => selectRegion(val)}
                                                                    className="RegionDropDown form-control"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    <fieldset disabled={DisabledValue}>
                                                        {/* Address */}
                                                        <Row>
                                                            <Col md={6} className="mb-3">
                                                                <Form.Group controlId="validationCity">
                                                                    <Form.Control
                                                                        required
                                                                        type="text"
                                                                        placeholder="City"
                                                                        value={submitedCity}
                                                                        onChange={handleCityChange}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={6} className="mb-3">
                                                                <Form.Group controlId="validationStreet">
                                                                    <Form.Control
                                                                        required
                                                                        type="text"
                                                                        placeholder="Street name"
                                                                        value={submitedStreet}
                                                                        onChange={handleStreetChange}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6} className="mb-3">
                                                                <Form.Group controlId="validationHouseN">
                                                                    <Form.Control
                                                                        required
                                                                        type="text"
                                                                        placeholder="House № / Addition"
                                                                        value={submitedHouseN}
                                                                        onChange={handleHouseNChange}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={6} className="mb-3">
                                                                <Form.Group controlId="validationZip">
                                                                    <Form.Control
                                                                        required
                                                                        type="text"
                                                                        placeholder="Postal code"
                                                                        value={submitedZip}
                                                                        onChange={handleZipChange}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>

                                                        {/* Consent */}
                                                        <Form.Group className="mb-3">
                                                            <Form.Check type='checkbox' id={`privacy-consent`}>
                                                                <Form.Check.Input required type='checkbox' />
                                                                <Form.Check.Label>
                                                                    I want my order to be sent to this address and I agree to {<a href={PrivacyPolicy} target="_blank" rel="noreferrer">the privacy policy</a>}
                                                                </Form.Check.Label>
                                                                <Form.Control.Feedback type="invalid">You should agree with the privacy policy</Form.Control.Feedback>
                                                            </Form.Check>
                                                        </Form.Group>
                                                    </fieldset>

                                                    {/* Actions */}
                                                    <div className="d-flex justify-content-between">
                                                        <Button variant="outline-secondary" onClick={() => history.goBack()}>Back</Button>
                                                        <Button variant="outline-success" type="submit">Proceed to checkout</Button>
                                                    </div>
                                                </Form>
                                            </Col>
                                        </Row>
                                    </div>
                                )
            }

            return (
                <>


                    <FormValids 
                    onSubmit={this.onSubmit}
                    />

                </>
            )
        }   
}
export default withContext(Formsincheckout)